<script setup lang="ts">
useHead({
  meta: [
    {
      name: 'viewport',
      content:
        'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, viewport-fit=cover'
    },
    {
      name: 'robots',
      content: 'noindex'
    }
  ],
  bodyAttrs: {
    class: 'dark:tw-bg-gray-800'
  }
})

const route = useRoute()

const mainStore = useMainStore()

mainStore.isLoadedFromApp = true

if (route.query.location) {
  const [lat, lon] = (route.query.location as string).split('|')

  if (lat && lon) {
    mainStore.userLocation = {
      latitude: parseFloat(lat),
      longitude: parseFloat(lon),
      type: 'app'
    }
  }
}
</script>

<template>
  <NuxtPage />
</template>

<style>
html {
  font-family:
    -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  -webkit-tap-highlight-color: transparent;
  user-select: none;
}

a,
img {
  -webkit-touch-callout: none;
  -webkit-user-drag: none;
}
</style>
